import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'monorepo-view-more-list-modal',
  templateUrl: './view-more-list-modal.component.html',
  styleUrls: ['./view-more-list-modal.component.scss'],
})
export class ViewMoreListModalComponent {
  @Input() label = '';
  @Input() values: TViewMoreValues = [];

  constructor(private modalController: ModalController) {}

  closeModal() {
    this.modalController.dismiss();
  }
}

export type TViewMoreValues = {
  displayName: string | number;
  icon?: string;
}[];
